export default __webpack_public_path__ + "static/media/sustentabilidade2.12833515.jpg";